import React, { useState } from 'react';
import Chatbot from '../../Chatbot';
import { SiChatbot } from "react-icons/si";
import '../../common/Styles.css'

export const ChatbotChild = () => {
    const [chatOpen, setChatOpen] = useState(false);

    return (
        <div className="app chatbot-container">
            <button
                name="chatbot-btn"
                onClick={() => setChatOpen(!chatOpen)}
                className='chatbot-container-btn'
                ><SiChatbot /></button>
            <Chatbot isOpen={chatOpen} onClose={() => setChatOpen(false)} />
        </div>
    )
}